import { withFilters } from '@sbv-clients/domain-ui-shared';

import { DashboardContext, useDashboardContext } from './page-context';

const pageKey = 'WorkforceDashboard';

const Context = withFilters(useDashboardContext, DashboardContext, pageKey);

export const Page = Context.Page;
export const useContextFn = Context.useContextFn;
